import FileSaver from 'file-saver';

export const isBlob = data => (data instanceof Blob ? data : new Blob([data]));

export default (fileData, fileName) =>
  FileSaver.saveAs(isBlob(fileData), fileName);
